module.exports = __webpack_public_path__ + "static/media/s7.7d84751f.jfif";